import React from 'react';

const brands = [
  "美 的", "海 尔", "海 信", "老 板 电 器", "TCL", "奥 克 斯", "华 帝", "顾 家 家 居", "慕 思"
];

const Partners: React.FC = () => {
  return (
    <section className="pb-32 bg-black overflow-hidden pt-10"> 
      <div className="max-w-7xl mx-auto px-4 text-center mb-16">
        <h2 className="text-2xl md:text-5xl font-semibold text-white mb-6 tracking-tight">
          众多企业用户，与我们一起开启共创
        </h2>
        <p className="text-gray-400 text-sm md:text-lg tracking-wider font-light border-b border-white/10 pb-8 inline-block px-12">
          每月新增 50+ 合作企业
        </p>
      </div>
      
      <div className="relative flex overflow-x-hidden group">
        <div className="animate-marquee whitespace-nowrap flex items-center gap-16 pl-16">
          {brands.map((brand, index) => (
            <span key={`b1-${index}`} className="text-4xl md:text-6xl font-bold text-zinc-800 hover:text-zinc-500 transition-colors duration-500 cursor-default select-none">
              {brand}
            </span>
          ))}
          {brands.map((brand, index) => (
            <span key={`b2-${index}`} className="text-4xl md:text-6xl font-bold text-zinc-800 hover:text-zinc-500 transition-colors duration-500 cursor-default select-none">
              {brand}
            </span>
          ))}
           {brands.map((brand, index) => (
            <span key={`b3-${index}`} className="text-4xl md:text-6xl font-bold text-zinc-800 hover:text-zinc-500 transition-colors duration-500 cursor-default select-none">
              {brand}
            </span>
          ))}
        </div>
        
        {/* Fade Edges */}
        <div className="absolute top-0 left-0 w-32 h-full bg-gradient-to-r from-black to-transparent z-10 pointer-events-none"></div>
        <div className="absolute top-0 right-0 w-32 h-full bg-gradient-to-l from-black to-transparent z-10 pointer-events-none"></div>
      </div>
    </section>
  );
};

export default Partners;